module.exports = "/_next/static/images/UnifyCustomerProfile@2x-88339a873fcb96b52fd77fe0d0bd6702.png";